import React from "react"
import Container from "../container"
import { SIcon } from "../iconSymbols"
import * as styles from "./footer.module.scss"
import {
  TAOBAO,
  TIANMAO,
  XIAOHONGSHU,
  WEIXIN,
  WEIBO,
  BILIBILI,
  INS,
  GCORESAPP,
} from "@data/icons"
import Clickable from "../clickable"
import IconsClickable from "./icons"

const ONLINE_BUY = [TAOBAO, TIANMAO]
const MEDIA_LIST = [XIAOHONGSHU, WEIXIN, WEIBO, BILIBILI, INS]

const Footer = React.memo((props) => {
  return (
    <div className={styles.container}>
      <Container className={styles.main}>
        <div className={styles.infoContainer}>
          <div className={styles.leftCol}>
            <div>
              <h3>在线购买：</h3>
              <IconsClickable list={ONLINE_BUY} />
            </div>
            <div>
              <h3>App内购买：</h3>
              <IconsClickable list={[GCORESAPP]} />
            </div>
            <div>
              <h3>社交媒体：</h3>
              <IconsClickable list={MEDIA_LIST} />
            </div>
          </div>
          <div className={styles.rightCol}>
            <h3>关于：</h3>
            <p>
              <Clickable to="/about">
                吉考斯工业®（GCORES INDUSTRIES®）
              </Clickable>
              <Clickable to="/about">机组成员（GCREW MEMBER™）</Clickable>
              <Clickable appNavTo="https://www.gcores.com">
                GCORES机核®
              </Clickable>
            </p>
            <p>
              <Clickable to="/about/?tab=contact">授权合作与联络</Clickable>
            </p>
            <h3>
              Copyright © 2018 - 2024 GCORES INDUSTRIES. All Rights Reserved
            </h3>
          </div>
        </div>
      </Container>
      <SIcon name="gi_i_logo" className={styles.logo} />
    </div>
  )
})

Footer.displayName = "Footer"
export default Footer
